<nav class="sx-navmenu sxl-flex" [ngClass]="{ 'sxl-full-height': !isHandset, 'sx-navmenu__handset': isHandset }" >
    @if(bannerMessages && bannerMessages.length > 0){
        <button class="sx-navmenu__navbutton" 
            id="top_nav_system_messages"
            matTooltip="{{ 'core.header.system_messages' | translate }}"
            (click)="onSystemMessagesClick()">
            <div class="sxl-flex sxl-full-height">
                <div class="sxl-flex sxl-full-height sxl-items-center sxl-justify-center sxl-flex-1">
                    <span class="sx-navmenu__icon sx-navmenu__system-messages-icon">
                        <svg class="sxl-full-height">
                            <use xlink:href="#sx-varning" href="#sx-varning" />
                        </svg>
                    </span>
                </div>
            </div>
        </button>
    }

    <button class="sx-navmenu__navbutton" id="top_nav_tips" 
        [ngClass]="{'sxl-flex-1': isHandset}"
        matTooltip="{{ 'core.header.tips.title' | translate }}" 
        [hidden]="!isHasMeteringPoints"
        (click)="onTipsClick()">
        <div class="sxl-flex sxl-full-height">
            <div class="sxl-flex sxl-full-height sxl-items-center sxl-justify-center sxl-flex-1">
                <span class="sx-navmenu__icon">
                    <svg class="sxl-full-height">
                        <use xlink:href="#sx-lightbulb" href="#sx-lightbulb" />
                    </svg>
                </span>
                @if(isLoggedIn){
                    <span class="sx-navmenu__notice-count" 
                        [matBadge]="unreadTipsCount"
                        [matBadgeOverlap]="true" 
                        [matBadgeHidden]="unreadTipsCount === 0">
                    </span>
                }
            </div>
        </div>
    </button>
    <button class="sx-navmenu__navbutton" id="top_nav_notification" 
        [ngClass]="{'sx-navmenu__navbutton--active': appRouter.url === '/secure/inbox/notifications', 'sxl-flex-1': isHandset, 'sx-navmenu__navbutton--active-menu sx-navmenu__navbutton__arrow': notificationTrigger.menuOpen}"
        matTooltip="{{ 'core.header.notifications.title' | translate }}"
        [matMenuTriggerFor]="notificationMenu" 
        #notificationTrigger="matMenuTrigger">
        <div class="sxl-flex sxl-full-height">
            <div class="sxl-flex sxl-full-height sxl-items-center sxl-justify-center sxl-flex-1">
                <span class="sx-navmenu__icon">
                    <svg class="sxl-full-height" viewbox="0 0 32 32">
                        <use xlink:href="#in-notiser" href="#in-notification" />
                    </svg>
                </span>
                @if(isLoggedIn){
                <span class="sx-navmenu__notice-count" 
                    [matBadge]="unreadNotificationCount"
                    [matBadgeOverlap]="true" 
                    [matBadgeHidden]="unreadNotificationCount === 0">
                </span>
                }
            </div>
        </div>
    </button>
    <mat-menu class="sx-notifications-menu" id="top_nav_notification_menu" #notificationMenu="matMenu" yPosition="below" overlapTrigger="false">
        <app-menu 
            [menuItems]="notificationMenuItems" 
            allItemsText="{{ 'core.header.notifications.all' | translate}}" 
            markAllAsReadText="{{ 'core.header.notifications.mark_all_as_read' | translate}}" 
            [isHandset]="isHandset"
            (menuRouteToClick)="onMenuRouteToClick()"
            [allItemsUrl]="'/secure/inbox/notifications'"
            [showTimestamps]="true"
            [evenOddRowStyle]="true">
        </app-menu>
    </mat-menu>
    <button class="sx-navmenu__navbutton" id="top_nav_messages" 
        [ngClass]="{'sx-navmenu__navbutton--active': appRouter.url === '/secure/inbox/messages', 'sxl-flex-1': isHandset}" 
        matTooltip="{{ 'core.header.messages' | translate }}"
        [hidden]="!isHasMeteringPoints"
        (click)="routeToMessages()">
        <div class="sxl-flex sxl-full-height">
            <div class="sxl-flex sxl-full-height sxl-items-center sxl-justify-center sxl-flex-1">
                <span class="sx-navmenu__icon">
                    <svg class="sxl-full-height">
                        <use xlink:href="#in-message" href="#in-message" />
                    </svg>
                    @if(isLoggedIn){
                        <span class="sx-navmenu__notice-count" 
                            [matBadge]="unreadMessagesCount"
                            [matBadgeOverlap]="true" 
                            [matBadgeHidden]="unreadMessagesCount === 0">
                        </span>
                    }
                </span>
            </div>
        </div>
    </button>
    @if(isLoggedIn){
        <button class="sx-navmenu__navbutton" id="top_nav_help" 
            [ngClass]="{'sx-navmenu__navbutton--active-menu sx-topheader__navbutton__arrow': helpTrigger.menuOpen, 'sxl-flex-1': isHandset }"
            matTooltip="{{ 'core.header.help' | translate }}"
            [matMenuTriggerFor]="helpmenu" 
            #helpTrigger="matMenuTrigger">
            <div class="sxl-flex sxl-full-height">
                <div class="sxl-flex sxl-full-height sxl-items-center sxl-justify-center sxl-flex-1">
                    <span class="sx-navmenu__icon">
                        <svg class="sxl-full-height">
                            <use xlink:href="#in-help" href="#in-help" />
                        </svg>
                    </span>
                </div>
            </div>
        </button>
        <mat-menu class="sx-help-menu" id="top_nav_help_menu" #helpmenu="matMenu" yPosition="below" overlapTrigger="false">
            <app-menu [menuItems]="helpMenuItems"></app-menu>
        </mat-menu>
        <button class="sx-navmenu__navbutton" id="top_nav_user" 
            [ngClass]="{'sx-navmenu__navbutton--active': appRouter.url === '/secure/user/info', 'sxl-flex-1': isHandset, 'sx-navmenu__navbutton--active-menu sx-navmenu__navbutton__arrow': accountTrigger.menuOpen}"
            [matTooltip]="userDisplayName"
            [matMenuTriggerFor]="usermenu" 
            #accountTrigger="matMenuTrigger">
            <div class="sxl-flex sxl-full-height">
                <div class="sxl-flex sxl-full-height sxl-items-center sxl-justify-center sxl-flex-1">
                    <span class="sx-navmenu__icon">
                        <svg class="sxl-full-height">
                            <use xlink:href="#in-user" href="#in-user" />
                        </svg>
                    </span>
                </div>
            </div>
        </button>
        <mat-menu class="sx-account-menu" id="top_nav_user" #usermenu="matMenu" yPosition="below" overlapTrigger="false">
            <app-menu [menuItems]="myMenuItems"></app-menu>
        </mat-menu>
    }
</nav>